<template>
  <div class="data_div">
    <!-- 标题 -->
    <div class="data_title_box">
      <i class="iconfont icon-dian"></i>
      <span>{{ title }}</span>
    </div>

    <!-- 搜索框 -->
    <div class="data_right_box">
      <div class="select_left">
        <!-- 模糊条件 -->
        <div class="search_box">
          <span> 关键字</span>
          <div>
            <el-input
              class="input_width input_inner"
              placeholder="请输入搜索关键字"
              v-model="keywordVal"
              maxLength="20"
              clearable
            ></el-input>
          </div>
        </div>

        <!-- 单位选择 -->
        <div class="search_box">
          <span>单位选择</span>
          <div>
            <SelectTree
              :props="props"
              :options="companyList"
              :value="companySelVal"
              :clearable="isClearable"
              :accordion="isAccordion"
              @getValue="companyChange"
            />
          </div>
        </div>

        <!-- 电站选择 -->
        <div class="search_box">
          <span>电站选择</span>
          <div>
            <el-select
              v-model="stationSelVal"
              placeholder="请选择内容"
              @change="stationChange"
            >
              <el-option
                v-for="item in stationList"
                :key="item.id"
                :label="item.stationName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>

        <!-- 模块类型选择 -->
        <div class="search_box">
          <span>模块类型</span>
          <div>
            <el-select
              v-model="modelTypeSelVal"
              placeholder="请选择内容"
              clearable
            >
              <el-option
                v-for="item in modelTypeList"
                :key="item.infoCode"
                :label="item.infoName"
                :value="item.infoCode"
              >
              </el-option>
            </el-select>
          </div>
        </div>

        <!-- 瞬时量选择 -->
        <div class="search_box">
          <span>瞬时量选择</span>
          <div>
            <el-select
              v-model="instantSelVal"
              placeholder="请选择内容"
              clearable
            >
              <el-option
                v-for="item in instantList"
                :key="item.id"
                :label="item.recordName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>

        <!-- 最新值显示选择 -->
        <div class="search_box">
          <span>最新值显示</span>
          <div>
            <el-select
              v-model="valDisplaySeVal"
              placeholder="请选择内容"
              clearable
            >
              <el-option
                v-for="item in valDisplayList"
                :key="item.infoCode"
                :label="item.infoName"
                :value="item.infoCode"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>

      <!-- 搜索按钮 -->
      <div class="btn_right">
        <button class="button_style0" @click="selectButClick()">
          <i class="iconfont icon-chaxun4"></i>查询
        </button>
      </div>
    </div>

    <!-- 翻页 -->
    <div class="pagination_div">
      <el-pagination
        background
        class="el_pag"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="pageTotal"
      >
      </el-pagination>
      <div class="function_button_div">
        <button class="button_style1 btn2" @click="addClick()">
          <i class="iconfont icon-tianjia3"></i>添加
        </button>
        <button class="button_style1" @click="delClick()">
          <i class="iconfont icon-shanchu"></i>删除
        </button>
      </div>
    </div>

    <!-- 数据表格 -->
    <div class="list_box">
      <el-table
        :data="dataList"
        class="my_el_table"
        style="width: 100%"
        height="100%"
        border
        v-loading="loading"
        element-loading-text="加载中，请稍后..."
        element-loading-background="#01232a"
      >
        <el-table-column label="Id" prop="id" width="" show-overflow-tooltip ></el-table-column>
        <el-table-column label="模块类型" prop="modelTypeStr" width="" show-overflow-tooltip ></el-table-column>
        <el-table-column label="记录名称" prop="recordName" width="" show-overflow-tooltip ></el-table-column>
        <!-- <el-table-column label="瞬时量" prop="dataId" width="" show-overflow-tooltip ></el-table-column> -->
        <el-table-column label="瞬时量" prop="dataId" width="" show-overflow-tooltip>
          <template slot-scope="scope">
              <span>
               {{ convertInstantName(scope.row.dataId) }}
              </span>
          </template>
        </el-table-column>
        <el-table-column label="显示颜色" prop="colorStr" width="" show-overflow-tooltip ></el-table-column>
        <el-table-column label="显示类型" prop="typeStr" width="" show-overflow-tooltip ></el-table-column>
        <el-table-column label="默认选中" prop="defChekedStr" width="" show-overflow-tooltip ></el-table-column>
        <el-table-column label="最新值显示标记" prop="valDisplayStr" width="" show-overflow-tooltip ></el-table-column>
        <el-table-column label="备注" prop="remark" width="" show-overflow-tooltip ></el-table-column>
        <el-table-column label="操作" width="200" >
        <template slot-scope="scope">
            <button class="button_style2" @click="detailsClick(scope.row.id)">详情</button>
            <i class="iconfont icon-vertical_line operation_line"></i>
            <button class="button_style2" @click="editClick(scope.row.id)"> 编辑</button>
            <i class="iconfont icon-vertical_line operation_line"></i>
            <button class="button_style2"  @click="delOneClick(scope.row.id, scope.row.recordName)">删除</button>
        </template>
        </el-table-column> 
      </el-table>
    </div>

    <el-dialog
      :visible.sync="dialogTableVisible"
      :append-to-body="true"
      :lock-scroll="false"
      :close-on-click-modal="false"
    >
      <div slot="title" class="dialog_title">{{ dialog.title }}</div>
      <div class="dialog_content">
        <el-form :model="dialog.elForm" :rules="dialog.rules" ref="addAlterForm">
            <el-form-item label="电站" prop="staId" label-width="17rem">
                <el-select v-model="dialog.elForm.staId" placeholder="请选择内容" @change="dialogStaChange">
                    <el-option
                    v-for="item in dialogStationList"
                    :key="item.id"
                    :label="item.stationName"
                    :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="模块类型" prop="modelType" label-width="17rem">
                <el-select v-model="dialog.elForm.modelType" placeholder="请选择内容" clearable>
                    <el-option v-for="item in modelTypeList"
                                :key="item.infoCode"
                                :label="item.infoName"
                                :value="item.infoCode">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="记录名称" prop="recordName" label-width="17rem">
                <el-input
                    v-model="dialog.elForm.recordName"
                    maxlength="20"
                    placeholder="请输入内容"></el-input>
                <span class="remark_span">不超过20个字符</span>
            </el-form-item>
            <el-form-item label="瞬时量" prop="dataId" label-width="17rem">
                <el-select v-model="dialog.elForm.dataId" placeholder="请选择内容" clearable >
                    <el-option v-for="item in dialogInstantList"
                                :key="item.id"
                                :label="item.recordName"
                                :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="显示颜色" prop="color" label-width="17rem">
                <el-select v-model="dialog.elForm.color" placeholder="请选择内容" clearable>
                    <el-option v-for="item in colorList"
                                :key="item.infoCode"
                                :label="item.infoName"
                                :value="item.infoCode">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="显示类型" prop="type" label-width="17rem">
                <el-select v-model="dialog.elForm.type" placeholder="请选择内容" clearable>
                    <el-option v-for="item in typeList"
                                :key="item.infoCode"
                                :label="item.infoName"
                                :value="item.infoCode">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="最新值显示标记" prop="valDisplay" label-width="17rem">
                <el-select v-model="dialog.elForm.valDisplay" placeholder="请选择内容" clearable>
                    <el-option v-for="item in valDisplayList"
                                :key="item.infoCode"
                                :label="item.infoName"
                                :value="item.infoCode">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="默认选中" prop="defCheked" label-width="17rem">
                <el-select v-model="dialog.elForm.defCheked" placeholder="请选择内容" clearable>
                    <el-option v-for="item in defChekedList"
                                :key="item.infoCode"
                                :label="item.infoName"
                                :value="item.infoCode">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="描述/备注" prop="remark" label-width="17rem">
                <el-input type="textarea" v-model="dialog.elForm.remark" maxlength="100"
                            placeholder="请输入内容"></el-input>
                <span class="remark_span">不超过100个字符</span>
            </el-form-item>
        </el-form>
        <table class="dialog_table" v-if="dialog.openType === 0">
          <tr>
            <td>添加用户</td>
            <td>{{ dialog.elForm.addUser }}</td>
          </tr>
          <tr>
            <td>添加时间</td>
            <td>{{ longToDate(dialog.elForm.addTime) }}</td>
          </tr>
          <tr>
            <td>最近一次修改用户</td>
            <td>{{ dialog.elForm.alterUser }}</td>
          </tr>
          <tr>
            <td>最近一次修改时间</td>
            <td>{{ longToDate(dialog.elForm.alterTime) }}</td>
          </tr>
        </table>
      </div>
      <div slot="footer" class="dialog_footer">
        <button class="button_style0" @click="dialogTableVisible=false"><i class="iconfont icon-quxiao1"></i>取消
        </button>
        <button class="button_style0" @click="submitClick('addAlterForm')" v-if="dialog.openType!=0"><i
            class="iconfont icon-tijiao"></i>保存
        </button>
        <button class="button_style0" @click="resetClick" >
          <i class="iconfont icon-zhongzhi3"></i>重置
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import myApi from "@/util/my-api";
import myConst from "@/util/my-const";
import fun from "@/util/util";
import SelectTree from "@/components/iems/tree-select.vue";
export default {
  components: { SelectTree },
  data() {
    return {
      title: "电站实时曲线配置",
      keywordVal: "", //关键字
      companyList: [], //单位列表
      stationList: [], //电站列表
      stationListAll: [], //全部电站列表
      companySelVal: null, //单位选择内容
      stationSelVal: "", //电站选择内容
      isClearable: true, // 可清空（可选）
      isAccordion: true, // 可收起（可选）
      props: {
        // 配置项（必选）
        value: "id",
        label: "comName",
        children: "children",
        // disabled:true
      },

      modelTypeList: [], //模块类型列表
      modelTypeSelVal: "", //模块类型选择内容
      instantList: [], //瞬时量列表
      instantSelVal: "", //瞬时量选择内容
      valDisplayList: [], //最新值显示标记列表
      valDisplaySeVal: "", //最新值显示标记选择内容
      colorList:[],//颜色列表
      typeList:[], //类型列表
      defChekedList:[], //默认选中列表
      currentPage: 1, //当前页数
      pageSize: 500, //每页条数
      pageTotal: 0, //记录总数
      dataList: [], //数据列表
      loading: false, //表格加载中状态
      dialogTableVisible: false, //弹窗状态
      //   弹窗数据
      dialogStationList: [], //弹窗的电站列表
      dialogInstantList: [], //弹窗的瞬时量列表
      dialog: {
        title: "",
        openType: 0, //操作类型，0：详情，1：修改，2：添加
        rules: {
            staId: [
            {required: true, message: "请选择内容", trigger: 'change'}
          ],
          dataId: [
            {required: true, message: "请选择内容", trigger: 'change'}
          ],
          modelType: [
            {required: true, message: "请选择内容", trigger: 'change'}
          ],
        },
        elForm: {
            id:"",
            recordName:"", //记录名称
            modelType:"", //模块类型
            staId:"", //电站
            dataId:"", //瞬时量
            color:"", //显示颜色
            type:"", //显示类型
            valDisplay:"", //最新值显示标记
            defCheked:"", //默认选中
            remark:"", //描述/备注
        },
      },
    };
  },

  mounted() {
    this.loadCompanyList();
    this.loadStationList();
    this.getValDisplaySign();
    this.getColor()
    this.getType()
  },

  methods: {
    //转化日期格式
    longToDate(val) {
      return fun.longToDate(val);
    },

    //获取最新值显示标记
    getValDisplaySign() {
      this.$axios.get(myApi.getValDisplay).then((res) => {
        if (res.data.code === myConst.code.success) {
          this.valDisplayList = res.data.data;
        } else {
          this.valDisplayList = [];
        }
      });
    },

     //获取显示颜色
     getColor() {
      this.$axios
        .get(myApi.getDisplayColor)
        .then((res) => {
          if (res.data.code === myConst.code.success) {
            this.colorList = res.data.data;
          } else {
            this.colorList = [];
          }
        })
        .catch(() => {
          this.colorList = [];
        });
    },

     //获取显示类型
     getType() {
      this.$axios
        .get(myApi.getDisplayType)
        .then((res) => {
          if (res.data.code === myConst.code.success) {
            this.typeList = res.data.data;
          } else {
            this.typeList = [];
          }
        })
        .catch(() => {
          this.typeList = [];
        });
    },

    //转换瞬时量名称
    convertInstantName(instantId) {
      const item = this.instantList.find(curve => curve.id === instantId);
      return item ? item.recordName : null;
    },

    //查询单位列表
    loadCompanyList() {
      this.$axios.get(myApi.getBusComTreeList).then((res) => {
        if (res.data.code === myConst.code.success) {
          this.companyList = res.data.data;
        } else {
          this.companyList = [];
        }
      });
    },

    //查询电站列表
    loadStationList() {
      this.$axios.get(myApi.getPermissionStation).then((res) => {
        if (res.data.code === myConst.code.success) {
          this.dialogStationList = res.data.data;
          this.stationListAll = res.data.data;
          this.companyChange(this.companySelVal); //调用单位选择事件
          this.loadDataList();
        } else {
          this.stationListAll = [];
        }
      });
    },

    // 取值(树形结构选择事件)
    companyChange(val) {
      this.companySelVal = val;
      if (fun.isNull(val)) {
        this.stationList = this.stationListAll;
      } else {
        this.stationList = this.stationListAll.filter(
          (x) => x.companyId === this.companySelVal
        );
      }
      if (this.stationList.length > 0) {
        this.stationSelVal = this.stationList[0].id;
        this.loadInstantList(false, this.stationSelVal);
      } else {
        this.stationSelVal = "";
        this.instantSelVal = "";
        this.instantList = [];
      }
    },

    //电站选择事件
    stationChange() {
      this.loadInstantList(false, this.stationSelVal);
    },

    //根据电站获取瞬时量
    loadInstantList(isDialogData, staId) {
      this.$axios.get(myApi.getListBusNew + "?staId=" + staId).then((res) => {
        if (res.data.code === myConst.code.success) {
          if (isDialogData) {
            this.dialogInstantList = res.data.data;
          } else {
            this.instantList = res.data.data;
            if (this.instantList.length > 0) {
              if (fun.isNull(this.instantSelVal)) {
                this.instantSelVal = "";
              } else {
                this.instantSelVal = this.instantList[0].id;
              }
            } else {
              this.instantSelVal = "";
              this.instantList = [];
            }
          }
        }
      });
    },

    //加载数据列表
    loadDataList() {
      let data = {
        keyword: this.keywordVal.trim(),
        modelType: this.modelTypeSelVal,
        staId: this.stationSelVal,
        dataId: this.instantSelVal,
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        valDisplay: this.valDisplaySeVal,
      };
      this.loading = true;
      this.$axios
        .post(myApi.getStatRealCurveList, data)
        .then((res) => {
          if (res.data.code === myConst.code.success) {
            this.loading = false;
            this.dataList = res.data.data.list;
            this.pageTotal = res.data.data.total;
          } else {
            this.loading = false;
            this.dataList = [];
            this.pageTotal = 0;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },

    //查询按钮
    selectButClick() {
      this.currentPage = 1;
      this.loadDataList();
    },

    // 翻页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadDataList();
    },

    //添加按钮
    addClick() {
      this.resetData();
      this.dialog.title = "添加"
      this.dialogTableVisible = true
      this.dialog.openType = 2;
      this.loadInstantList(true,this.dialog.elForm.staId)
    },

    //删除按钮
    delClick() {
        this.$confirm(`确认删除该电站下所有的数据吗？`,
          "提示", {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            dangerouslyUseHTMLString: true,
          }).then(()=>{
            let data = {
                staId: this.stationSelVal
            }
            this.$axios.post(myApi.deleteStatRealCurve, data).then(res=>{
                if (res.data.code === myConst.code.success){
                    this.loadDataList()
                    this.$message({message: res.data.data, type: "success"})
                }
            })
          }).catch(()=>{})  
    },

    //详情按钮
    detailsClick(id){
      this.dialogTableVisible = true
      this.dialog.title = '详情'
      this.dialog.openType = 0;
      this.getOneData(id)
    },

    //编辑按钮
    editClick(id){
        this.dialogTableVisible = true
        this.dialog.title = '编辑'
        this.dialog.openType = 1;
        this.getOneData(id)
    },

    //删除一个记录按钮
    delOneClick(id,name){
        this.$confirm(`确认删除记录名称为 <span style="color: red;">${name}</span> 这条数据吗？`,
          "提示", {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            dangerouslyUseHTMLString: true,
          }).then(()=>{
            let data = {
                id: id
            }
            this.$axios.post(myApi.deleteStatRealCurve, data).then(res=>{
                if (res.data.code === myConst.code.success){
                    this.loadDataList()
                    this.$message({message: res.data.data, type: "success"})
                }
            })
          }).catch(()=>{})
    },

    //弹窗电站选择事件
    dialogStaChange(){
        this.dialog.elForm.dataId = ""
        this.loadInstantList(true,this.dialog.elForm.staId)
    },

    //根据id查询单条记录
    getOneData(id){
        this.$axios.get(myApi.getOnestatRealCurveInfo + '?id=' + id).then(res=>{
            if (res.data.code === myConst.code.success){
                this.dialog.elForm = res.data.data
                this.dialog.elForm.color = this.dialog.elForm.color + ""
                this.dialog.elForm.type = this.dialog.elForm.type + ""
                this.dialog.elForm.valDisplay = this.dialog.elForm.valDisplay + ""
                this.dialog.elForm.defCheked = this.dialog.elForm.defCheked + ""
                this.loadInstantList(true,this.dialog.elForm.staId)
            } 
        })
    },

    // 提交表单按钮
    submitClick(formName){
        this.$refs[formName].validate(valid=>{
            if (valid){
                let data = {
                    id:this.dialog.elForm.id,
                    staId:this.dialog.elForm.staId,
                    recordName:this.dialog.elForm.recordName,
                    modelType:this.dialog.elForm.modelType,
                    dataId:this.dialog.elForm.dataId,
                    color:this.dialog.elForm.color,
                    type:this.dialog.elForm.type,
                    valDisplay:this.dialog.elForm.valDisplay,
                    defCheked:this.dialog.elForm.defCheked,
                    remark:this.dialog.elForm.remark,
                }
                if (this.dialog.openType === 2){
                    this.$confirm("确认要添加吗？", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                    }).then(()=>{
                        this.$axios.post(myApi.addStatRealCurve, data).then(res=>{
                            if (res.data.code === myConst.code.success){
                                this.loadDataList()
                                this.$message({message: res.data.data, type: "success"})
                            }
                        })
                    }).catch(()=>{})
                } else if(this.dialog.openType === 1) {
                    this.$confirm("确认保存修改吗？", "提示", {
                            confirmButtonText: "确认",
                            cancelButtonText: "取消",
                        }).then(()=>{
                            this.$axios.post(myApi.alterStatRealCurve, data).then(res=>{
                                if (res.data.code === myConst.code.success) {
                                    this.loadDataList()
                                    this.$message({message: res.data.data, type: "success"})
                                }
                            })
                        }).catch(()=>{})
                }
            }
        })
    },

    //表单重置按钮
    resetClick() {
      if (this.dialog.openType === 2) {//如果是添加 则重置数据
        this.resetData()
      } else {
        this.getOneData(this.dialog.elForm.id)
      }
    },

    //重置数据
    resetData(){
        return this.dialog.elForm = {
            id:"",
            recordName:"", //记录名称
            modelType:"", //模块类型
            staId:this.stationSelVal, //电站
            dataId:"", //瞬时量
            color:this.colorList[0].infoCode, //显示颜色
            type:this.typeList[0].infoCode, //显示类型
            valDisplay:this.valDisplayList[0].infoCode, //最新值显示标记
            defCheked:0, //默认选中
            remark:"", //描述/备注
        }
    }
  },
};
</script>

<style scoped>
@import "~@/assets/css/configInfo.css";
.btn2 {
  margin-right: 2rem;
}
</style>